import { useEffect, useState } from 'react';

const usePoolStartCheck = (startDate) => {
    const [hasPoolStarted, setHasPoolStarted] = useState(false);

    useEffect(() => {
        if (!startDate) return;

        const checkTime = () => {
            const now = new Date().getTime();
            const start = new Date(startDate).getTime();
            setHasPoolStarted(now >= start); 
        };

        checkTime();

        const interval = setInterval(checkTime, 1000); 

        return () => clearInterval(interval); 
    }, [startDate]);

    return hasPoolStarted;
};

export default usePoolStartCheck;
